import { Link } from 'react-router';
import { useSearchParams } from '../../common/hooks/useSearchParams.js';
import { lastModifiedMsg, productTypeMsg, t } from '../../common/i18n/index.js';
import {
  DEVICE_SELECTION_PRODUCT_TYPE_PARAM,
  MDM_ID_PARAM,
  getDeviceSelectionPath,
  getDeviceSelectionProductTypeLabel,
} from '../../common/utils/deviceListTabsUtilsCoCo.js';
import {
  DeviceSelectionListColumnCoCo,
  filterDeviceSelectionListItems,
  sortDeviceSelectionListItems,
  toDeviceSelectionListItem,
} from '../../common/utils/deviceSelectionListUtilsCoCo.js';
import { TimestampColumn } from '../CatalogList/TimestampColumn.js';
import { Highlight } from '../Highlight/Highlight.js';
import { Table, TableUrlParams } from '../Table/index.js';
import type { CLTableColumn, CLTableRow } from '../../common/types/componentLibrary';
import type { EmployeeProductSelectionResponse } from '../../generated/api/employeeProductSelectionResponse.js';

const getColumns = (): CLTableColumn[] => [
  { key: DeviceSelectionListColumnCoCo.NAME, label: t.VJ0T('Name of device selection'), sortable: true, width: '30%' },
  { key: DeviceSelectionListColumnCoCo.PRODUCT_TYPE, label: t.R6HP(productTypeMsg), sortable: true },
  { key: DeviceSelectionListColumnCoCo.LAST_MODIFIED, label: t.PM1H(lastModifiedMsg), sortable: true },
];

export interface DeviceSelectionListCoCoProps {
  deviceSelections: EmployeeProductSelectionResponse[];
}

export const DeviceSelectionListCoCo = ({ deviceSelections }: DeviceSelectionListCoCoProps) => {
  const {
    [MDM_ID_PARAM]: mdmId,
    [TableUrlParams.SEARCH]: search,
    [TableUrlParams.SORT]: sort,
    [TableUrlParams.ORDER]: order,
    [DEVICE_SELECTION_PRODUCT_TYPE_PARAM]: productTypeFilter,
  } = useSearchParams<{
    [MDM_ID_PARAM]?: string;
    [TableUrlParams.SEARCH]?: string;
    [TableUrlParams.SORT]?: string;
    [TableUrlParams.ORDER]?: string;
    [DEVICE_SELECTION_PRODUCT_TYPE_PARAM]?: string;
  }>();
  const searchTerms = search?.split(' ') ?? [];

  const rows: CLTableRow[] = sortDeviceSelectionListItems(
    filterDeviceSelectionListItems(deviceSelections.map(toDeviceSelectionListItem), search, productTypeFilter),
    sort,
    order
  ).map(item => ({
    [DeviceSelectionListColumnCoCo.NAME]: (
      <Link to={getDeviceSelectionPath(item.uuid, mdmId)}>
        <Highlight text={item.name} highlights={searchTerms} />
      </Link>
    ),
    [DeviceSelectionListColumnCoCo.PRODUCT_TYPE]: getDeviceSelectionProductTypeLabel(item.productType),
    [DeviceSelectionListColumnCoCo.LAST_MODIFIED]: <TimestampColumn timestamp={item.lastModified} />,
  }));

  return (
    <div className="of-device-selection-list-coco" data-testid="device-selection-list-coco">
      <Table columns={getColumns()} rows={rows} valignText="top" noItemsText={t.OW10('No device selections')} />
    </div>
  );
};
